import { SHOW_BOOKING_DIALOG } from "./types";

const showBookingDialog = () => ({
  type: SHOW_BOOKING_DIALOG,
});

export default showBookingDialog;
